import React, { Component } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  ListItem,
  Tab,
  Tabs,
} from '@material-ui/core'
import { EditableTextField } from '../../../../components/common/EditableComponents'
import TaxOption from '../../../../components/TaxOption/TaxOption'
import { getSession } from '../../../../utils/api'
import { emptyDeliveryTaxOption, scrollElementIntoView } from '../../../../utils/common'
import { postDeliveryTaxRate } from '../../../../actions/shop'
import { openErrorMessage, openSuccessMessage } from '../../../../actions/message'
import { isValidString } from '../../../../utils/string'

class ModalDeliveryTaxRate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedTaxToEdit: null,
      activeTab: 'Cannabis',
      lastModifiedState: null,
      taxDisplayNames: [],
    }
  }

  componentDidMount() {
    this.setState(
      {
        selectedTaxToEdit: { ...emptyDeliveryTaxOption },
      },
      () => {
        scrollElementIntoView('selected-tax')
      },
    )
  }


  closeModalTaxes = () => {
    this.props.onClose && this.props.onClose()
  }

  saveTaxes = () => {
    const { selectedTaxToEdit = {} } = this.state

    const { name = '' } = selectedTaxToEdit || {}

    if (!isValidString(name)) {
      return this.props.dispatch(openErrorMessage('Please enter name for delivery tax rate'))
    }

    this.props.dispatch(postDeliveryTaxRate(selectedTaxToEdit)).then((res) => {
      this.props.dispatch(openSuccessMessage('Delivery Tax rate saved successfully'))
      this.setState({
        selectedTaxToEdit: { ...emptyDeliveryTaxOption },
      })
      this.props.getNameTaxRule && this.props.getNameTaxRule()
      this.props.setDeliveryTaxRate && this.props.setDeliveryTaxRate(res)
      this.props.onClose && this.props.onClose()
    })
  }

  onChange = (key, isCheckBox) => (event) => {
    const value = isCheckBox ? event.target.checked : event.target.value
    const { selectedTaxToEdit } = this.state
    this.setState({
      selectedTaxToEdit: {
        ...selectedTaxToEdit,
        [key]: value,
        active: true,
      },
    })
  }

  disableEdit = (disableEditCallback) => {
    disableEditCallback && disableEditCallback()
  }

  changeActiveTab = (e, value) => {
    this.setState({
      activeTab: value,
    })
  }

  onChangeTaxOptions = (key, value, afterSave) => {
    const { activeTab } = this.state
    let optionKey = key
    if (activeTab == 'NonCannabis') {
      optionKey = this.getKeyForNonCannabis(key)
    }

    this.updateTaxOption(optionKey, value, afterSave)
  }

  updateTaxOption = (key, value, afterSave) => {
    this.setState((prevState) => ({
      selectedTaxToEdit: {
        ...prevState.selectedTaxToEdit,
        [key]: value,
      },
    }))
    afterSave && afterSave()
  }

  getKeyForNonCannabis = (key) => {
    let nonCannabisKey = ''
    switch (key) {
      case 'useComplexTax':
        nonCannabisKey = 'nonCannabisUseComplexTax'
        break
      case 'taxOrder':
        nonCannabisKey = 'nonCannabisTaxOrder'
        break
      case 'taxInfo':
        nonCannabisKey = 'nonCannabisTaxInfo'
        break
      case 'taxTables':
        nonCannabisKey = 'nonCannabisTaxTables'
        break
    }
    return nonCannabisKey
  }

  render() {
    const { open, isNalTaxesOnly, isNalExciseAfterCityTax, consumerTypes} = this.props
    const {
      selectedTaxToEdit = null,
      activeTab = 'Cannabis',
      lastModifiedState,
      taxDisplayNames = [],
    } = this.state
    const editMode = true
    const session = getSession()
    const { assignedShop = {} } = session || {}

    let nonCannabisData = {}
    if (selectedTaxToEdit) {
      nonCannabisData = {
        ...selectedTaxToEdit,
        useComplexTax: selectedTaxToEdit.nonCannabisUseComplexTax,
        taxOrder: selectedTaxToEdit.nonCannabisTaxOrder,
        taxInfo: selectedTaxToEdit.nonCannabisTaxInfo,
        taxTables: selectedTaxToEdit.nonCannabisTaxTables,
      }
    }

    return (
      <Dialog
        maxWidth={'md'}
        open={open}
        onClose={this.closeModalTaxes}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle id="alert-dialog-title">Delivery Tax Rates</DialogTitle>
        <DialogContent className="ModalContent dialog-content">
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                Name
              </Grid>
              <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                <EditableTextField
                  valueToRender={selectedTaxToEdit && selectedTaxToEdit.name}
                  value={selectedTaxToEdit && selectedTaxToEdit.name}
                  onChange={this.onChange('name')}
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  editMode={editMode}
                />
              </Grid>
            </Grid>
          </ListItem>
          <div className="delivery-tax-options">
            <Tabs
              value={activeTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.changeActiveTab}
              centered
              className="margin-bottom-small"
            >
              <Tab label="Cannabis Tax" value="Cannabis" />
              <Tab label="Non-cannabis Tax" value="NonCannabis" />
            </Tabs>
            {activeTab === 'Cannabis' ? (
              <TaxOption
                editMode={editMode}
                data={{ ...selectedTaxToEdit, enableExciseTax: assignedShop.enableExciseTax }}
                onSave={this.disableEdit}
                lastModified={lastModifiedState}
                hideEditAction={true}
                onChange={this.onChangeTaxOptions}
                showEdit={editMode}
                taxDisplayNames={taxDisplayNames}
                hideTaxNames
                isNalTaxesOnly={isNalTaxesOnly}
                isNalExciseAfterCityTax={isNalExciseAfterCityTax}
                consumerTypes={consumerTypes}
              />
            ) : null}
            {activeTab === 'NonCannabis' ? (
              <TaxOption
                editMode={editMode}
                data={{ ...nonCannabisData, enableExciseTax: assignedShop.enableExciseTax }}
                onSave={this.disableEdit}
                lastModified={lastModifiedState}
                hideEditAction={true}
                onChange={this.onChangeTaxOptions}
                showEdit={editMode}
                taxDisplayNames={taxDisplayNames}
                isNonCannabis
                hideTaxNames
                consumerTypes={consumerTypes}
              />
            ) : null}
          </div>
        </DialogContent>
        <DialogActions className="taxes-dialog-buttons">
          <Button className="button-white-and-red" onClick={this.closeModalTaxes}>
            <span className="button-text">Cancel</span>
          </Button>
          <Button className="button-blue-and-white" onClick={this.saveTaxes}>
            <span className="button-text">Save</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ModalDeliveryTaxRate



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/Modals/ModalDeliveryTaxRate.js